export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/clips-icon.svg?1f1e6d491e2a92306193b5208a73a8f5";